import * as ActionTypes from 'actions/ActionTypes'
import PROFILE_CONFIG from 'features/desktop-activation-feature/config'
import produce from 'immer'
import { IMAGE_OVERLAY_MAX_SIZE_DEFAULT } from '~/constant'


/**
 * @typedef {object} App
 * @property {string} edition
 * @property {string} installVersion
 * @property {string} externalLoginUrl
 * @property {string} logPath
 * @property {boolean} logsEnabled
 * @property {boolean} enableLiveStreamCaptureAPI
 * @property {number} imageOverlayMaxSize
 * @property {string | null} installError
 * @property {number | null} gpuComputeCap
 */

/**
 * @type {App}
 */
const initialState = {
  edition: localStorage.getItem(PROFILE_CONFIG.LOCAL_STORAGE_EDITION_VAR), // desktop only
  installVersion: null,
  externalLoginUrl: null,
  logPath: '',
  logsEnabled: false,
  enableLiveStreamCaptureAPI: false,
  imageOverlayMaxSize: IMAGE_OVERLAY_MAX_SIZE_DEFAULT,
  installError: null,
  gpuComputeCap: null,
}

const app = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.SET_INSTALL_VERSION: {
      const { installVer, externalLoginUrl, gpuComputeCap } = action.payload
      state.installVersion = installVer
      state.externalLoginUrl = externalLoginUrl
      if (gpuComputeCap) {
        state.gpuComputeCap = gpuComputeCap
      }
    }
      break
    case ActionTypes.SET_LOG_PATH: {
      const { logsEnabled, logPath } = action.payload
      state.logsEnabled = logsEnabled
      state.logPath = logPath
    }
      break
    case ActionTypes.SET_CONFIG: {
      const { config } = action.payload
      state.enableLiveStreamCaptureAPI = !!config?.enableLiveStreamCaptureAPI
      state.imageOverlayMaxSize = config?.imageOverlayMaxSize || IMAGE_OVERLAY_MAX_SIZE_DEFAULT
    }
      break
    case ActionTypes.SET_EDITION:
      state.edition = action.payload.edition
      break
    case ActionTypes.SET_INSTALL_COMPONENT_ERROR:
      state.installError = action.payload
      break
  }
}

export default produce(app, initialState)
